import Enumerator from '../global/Enumerator';

export const ticketCommercialLoanSecuritySplitTypes = [
  'property',
  'cach_deposit',
  'investment',
  'car_equipment',
  'other'
];

export class TicketCommercialLoanSecuritySplitType extends Enumerator {
  static default() {
    return this.of('property');
  }
}

TicketCommercialLoanSecuritySplitType.initEnum({
  property: {
    get id() {
      return 'property';
    },
    get title() {
      return 'Property';
    },
    get weight() {
      return 1;
    }
  },
  cach_deposit: {
    get id() {
      return 'cach_deposit';
    },
    get title() {
      return 'Cash deposit';
    },
    get weight() {
      return 2;
    }
  },
  investment: {
    get id() {
      return 'investment';
    },
    get title() {
      return 'Investment';
    },
    get weight() {
      return 3;
    }
  },
  car_equipment: {
    get id() {
      return 'car_equipment';
    },
    get title() {
      return 'Car equipment';
    },
    get weight() {
      return 4;
    }
  },
  other: {
    get id() {
      return 'other';
    },
    get title() {
      return 'Other';
    },
    get weight() {
      return 4;
    }
  }
});

export default {
  ticketCommercialLoanSecuritySplitTypes,
  TicketCommercialLoanSecuritySplitType
};
